import * as React from 'react';
type Props = {
  className?: string;
};
export function Gift({ className }: Props) {
  return (
    <svg
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Gift"
      className={className}
    >
      <rect width={67} height={67} rx={33.5} fill="#E6F4E6" />
      <path
        d="M56.5916 23.3931H10.4081C10.183 23.3931 10.0005 23.5756 10.0005 23.8007V56.6549C10.0005 56.8801 10.183 57.0625 10.4081 57.0625H56.5916C56.8167 57.0625 56.9992 56.8801 56.9992 56.6549V23.8007C56.9992 23.5756 56.8167 23.3931 56.5916 23.3931Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M25.9528 47.9452C26.0466 47.9466 26.1377 47.9144 26.2099 47.8546C26.2821 47.7948 26.3308 47.7114 26.3469 47.6191C26.6555 45.8776 27.5674 44.3005 28.9227 43.1642C30.2781 42.028 31.9903 41.4051 33.7589 41.4051C35.5275 41.4051 37.2395 42.028 38.5948 43.1642C39.9501 44.3005 40.862 45.8776 41.1706 47.6191C41.1892 47.7103 41.2386 47.7923 41.3103 47.8516C41.3819 47.9109 41.4717 47.9439 41.5647 47.9452H47.5433C47.6013 47.946 47.6587 47.9341 47.7115 47.9102C47.7644 47.8863 47.8112 47.851 47.8488 47.8068C47.8865 47.7627 47.9139 47.7109 47.9291 47.6549C47.9444 47.599 47.9474 47.5402 47.9374 47.4831C47.6113 45.5809 45.9943 38.8687 39.6898 35.9338C37.8927 35.1143 35.9451 34.6763 33.9702 34.6471C31.9953 34.6179 30.036 34.9982 28.2155 35.7641C26.395 36.5301 24.7528 37.6651 23.3929 39.0975C22.033 40.5298 20.9848 42.2285 20.3142 44.0862C19.9042 45.1878 19.6436 46.3395 19.5396 47.5103C19.5339 47.5671 19.5403 47.6245 19.5582 47.6788C19.5761 47.7331 19.6054 47.783 19.6438 47.8253C19.6822 47.8675 19.7288 47.9013 19.7811 47.9243C19.8334 47.9473 19.8902 47.9591 19.9473 47.9588L25.9528 47.9452Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M21.9995 19.4387L10.2734 23.4063L21.9043 19.3301H22.0267H44.9756H45.098L56.7561 23.4063"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M33.5472 20.3356C32.6233 20.3356 31.9031 18.9768 31.0606 18.7594C30.2182 18.542 30.3271 18.9498 29.5798 18.8682L24.6746 29.5343C24.3893 30.3631 24.6747 30.5941 25.3948 30.0506L26.7536 28.9908C26.9308 28.8073 27.1561 28.6775 27.4037 28.6161C27.6513 28.5547 27.911 28.5642 28.1534 28.6436C28.3958 28.723 28.6111 28.8691 28.7744 29.0651C28.9377 29.261 29.0425 29.499 29.0769 29.7517L29.403 30.9202C29.634 31.7626 30.0688 31.7898 30.3677 30.9202L34.4439 19.9687C34.1951 20.189 33.8791 20.3184 33.5472 20.3356V20.3356Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M37.2436 18.7733C36.5643 18.7733 36.6187 18.5967 36.0345 18.7733C35.4502 18.95 35.0017 19.5208 34.4853 19.942C34.419 19.9812 34.3705 20.0443 34.3497 20.1185L33.3847 22.8359C33.3574 22.9245 33.3574 23.0193 33.3847 23.1078L36.0209 30.7575C36.3198 31.5863 36.741 31.5727 36.9855 30.7575L37.3116 29.5754C37.3461 29.3209 37.4521 29.0815 37.6171 28.8847C37.7822 28.688 37.9995 28.542 38.2441 28.4638C38.4887 28.3856 38.7505 28.3783 38.9991 28.4427C39.2477 28.5072 39.4729 28.6408 39.6486 28.828L41.0073 29.8743C41.7003 30.4178 42.0264 30.1868 41.7275 29.3579L37.2436 18.7733Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M23.3851 20.8383C20.7763 21.64 20.5044 19.9416 20.5044 18.1209V12.061C20.5394 11.6927 20.658 11.3373 20.851 11.0218C21.0441 10.7063 21.3067 10.4391 21.6187 10.2403C22.1 9.96513 22.6646 9.87335 23.2083 9.98205C25.8578 11.137 27.8825 12.0473 30.532 13.2158C30.532 13.2158 31.7956 13.6643 31.7956 14.2757L31.714 17.6317C31.6514 17.8783 31.526 18.1045 31.3497 18.2879C31.1735 18.4713 30.9524 18.6057 30.7085 18.678C27.0807 19.8601 26.2928 20.0503 23.3851 20.8383Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M43.5882 20.8382C46.2106 21.6398 46.4689 19.9414 46.4689 18.1207V12.0608C46.4344 11.694 46.3175 11.3397 46.1269 11.0245C45.9363 10.7092 45.677 10.4411 45.3683 10.2401C44.8819 9.96517 44.3132 9.8735 43.765 9.98187C41.0476 11.1368 39.1044 12.0472 36.4413 13.2157C36.4413 13.2157 35.1777 13.6641 35.1777 14.2755L35.2729 17.6316C35.3235 17.8814 35.4432 18.1122 35.6186 18.2972C35.794 18.4822 36.018 18.614 36.2648 18.6778C39.9606 19.8599 40.6941 20.0501 43.5882 20.8382Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M33.6145 13.0527H33.6009C31.8525 13.0527 30.4351 14.4701 30.4351 16.2186V17.0202C30.4351 18.7687 31.8525 20.1861 33.6009 20.1861H33.6145C35.363 20.1861 36.7804 18.7687 36.7804 17.0202V16.2186C36.7804 14.4701 35.363 13.0527 33.6145 13.0527Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
